module.exports = __webpack_public_path__ + "img/process-icon.7a5a971c.svg";